var $window = $(window);
var breakPoint = 1024;

var resizeFlag = false;
var windowWidth = $window.width();
var windowHeight = $window.height();

// メディアクエリ
var mql = window.matchMedia('screen and (max-width: 1199px)');

//ローディング
import {loading} from "../include/module";
loading();

//ページTOP
import {pageTop} from "../include/module";
pageTop();

//ヘッダーの開閉
import {headerToggle} from "../include/module";
headerToggle();

//ページ内リンクのアニメーション
import {anchorScroll} from "../include/module";
anchorScroll();

// preload
import {preload} from "../include/module";
preload();

// resizing
import {resizing} from "../include/module";
resizing();

// アニメーション
import {animationFire} from "../include/module";
animationFire();

// YouTubeのモーダル
import {youtubeModal} from "../include/module";
youtubeModal();

// swiper
const slider = () => {
  const el = '.swiper-container';
  const $el = $(el);
  const sliderLength = $('.swiper-container .swiper-wrapper li').length;
  const settings = {
    centeredSlides: true,
    speed: 800,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    watchOverflow: true,
    slidesPerView: 3,
    direction: 'horizontal',
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    // loopAdditionalSlides: sliderLength,
    breakpoints: {
      1199: {
        slidesPerView: 1,
        loopAdditionalSlides: 1,
      }
    },
  }

  let swiper;
  let flg = false;
  $(el).addClass('disabled');

  const checkBreakPoint = (mql) => {
    if (mql.matches) {
      console.log('sp');
      if(sliderLength <= 1){ //1or0
        if(typeof swiper === 'undefined'){}else{
          swiper.destroy(true,true);
          $(el).addClass('disabled');
          flg = false;
        }
      }
      if(sliderLength >= 2){　//2以上
        if(!flg){
          $(el).removeClass('disabled');
          swiper = new Swiper (el, settings);
          flg = true;
        }
      }
    } else {
      console.log('pc');
      if(sliderLength < 4 && sliderLength >= 1){　//2以上４未満
        if(typeof swiper === 'undefined'){}else{
          swiper.destroy(true,true);
          $(el).addClass('disabled');
          flg = false;
        }
      }
      if(sliderLength >= 4){ //4以上
        if(!flg){
          $(el).removeClass('disabled');
          const swiper = new Swiper (el, settings);
          flg = true;
        }
      }
    }
  }
  mql.addListener(checkBreakPoint);
  checkBreakPoint(mql);
};
slider();


// WEBPACK FOOTER //
// ./src/assets/js/index/script.js